<template>
  <div class="milestone-content" ref="targetRef">
    <div class="milestone-content-title"></div>
    <div class="milestone-content-content">
      <div
        class="milestone-item milestone-item-1"
        :class="{ finish: finishMilestone >= 1 }"
      >
        <div class="finish-tag finish-tag-blue"></div>
      </div>
      <div
        class="milestone-item milestone-item-2"
        :class="{ finish: finishMilestone >= 2 }"
      >
        <div class="finish-tag finish-tag-blue"></div>
      </div>
      <div
        class="milestone-item milestone-item-3"
        :class="{ finish: finishMilestone >= 3 }"
      >
        <div class="finish-tag finish-tag-orange"></div>
      </div>
      <div
        class="milestone-item milestone-item-4"
        :class="{ finish: finishMilestone >= 4 }"
      >
        <div class="finish-tag finish-tag-orange"></div>
      </div>
      <div
        class="milestone-item milestone-item-5"
        :class="{ finish: finishMilestone >= 5 }"
      >
        <div class="finish-tag finish-tag-yellow"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { watch, inject, ref, type Ref } from 'vue';
import { useMilestone } from '@/hooks/useMilestone';
import useViewPagePoint from '@/hooks/useViewPagePoint';

// 页面视图打点
const { targetRef } = useViewPagePoint("里程碑");

// 注入状态
const isReady = inject<Ref<boolean>>('isReady', ref(false));
const serverTimestamp = inject<Ref<number>>('serverTimestamp', ref(0));

// 使用里程碑逻辑
const { finishMilestone, updateMilestoneProgress } = useMilestone({
  serverTimestamp, // 传递响应式的 serverTimestamp
});

// 监听 isReady，当准备就绪时更新里程碑进度
watch(isReady, (ready) => {
  if (ready) {
    updateMilestoneProgress();
  }
}, { immediate: true });
</script>
